__turbopack_context__.v({
  "messageTextStyles": "notificationMessage-module-scss-module__u40_Xa__messageTextStyles",
  "messageWrapper": "notificationMessage-module-scss-module__u40_Xa__messageWrapper",
  "successStyles": "notificationMessage-module-scss-module__u40_Xa__successStyles",
});
